export default "__VITE_ASSET__42afa8c0__"